import React from 'react'
import Translate from 'App/i18n'
import translate from 'App/i18n/translate'
import {Form, Field} from 'simple-react-form'
import Text from './Text'
import Button from 'orionsoft-parts/lib/components/Button'
import styles from './styles.css'
import autobind from 'autobind-decorator'
import loginWithPassword from 'App/Root/loginWithPassword'
import TOS from './TOS'
// import Social from './Social'
import {withApollo} from 'react-apollo'
import PropTypes from 'prop-types'
import withOrganization from 'App/Decorators/withOrganization'
import contextUrl from '../../Root/contextUrl'
import { Link } from 'react-router'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import gql from 'graphql-tag'

@withOrganization

@withGraphQL(gql`
  query me {
    me {
      _id
      email
    }
  }
`)

@withApollo
export default class Login extends React.Component {
  state = {}

  static propTypes = {
    setLoading: PropTypes.func,
    setError: PropTypes.func,
    onSuccess: PropTypes.func,
    isLoading: PropTypes.bool,
    client: PropTypes.object,
    organization: PropTypes.object,
    me: PropTypes.object,
  }



  componentDidMount() {
    console.log("componentDidMount")
    /*
    if( !this.props.isGeolocationAvailable ) {
      console.log("!geolocationAvailable")
    } else {
      console.log("geolocationAvailable")
      if( !this.props.isGeolocationEnabled ){
        console.log("!isGeolocationEnabled")
      } else {
        console.log("isGeolocationEnabled")
        if(this.props.coords){
          this.setState({
            'latitud': this.props.coords.latitude,
            'longitud': this.props.coords.longitude
          })
        } else {
          console.log("!Coords")
        }
      }
    }  */
  }

  @autobind
  async login() {
    this.props.setLoading(true)
    this.props.setError(null)
    try {
      console.log('loginCall ')
      await loginWithPassword(this.state, this.props.client, this.props.organization, 
        this.state.latitud, this.state.longitud, contextUrl)
        localStorage.removeItem('copyText')
        this.props.onSuccess()
      } catch (e) {
        //this.props.setError(e.message)
      localStorage.setItem('copyText', this.state.email)
      console.log("Objeto error:", e);
      this.props.setLoading(false)
      let mensaje = e.message;
      console.log('Error ' + mensaje)
      if( mensaje === "GraphQL error: BLOCKED" ){
        console.log('Bloqueado')
        this.props.setError("Usuario bloqueado, debe resetear contraseña");
        setTimeout(() => {
           window.location.href='/forgot'
        }, 4000
      );
      } else {
        console.log('No bloqueado: '+ mensaje)
        this.props.setError("Login Incorrecto") 
      }
      //this.props.setError(e.message
    }
  }

  @autobind
  handleEmailKey(event) {
    if (event.charCode === 13 || event.keyCode === 13) {
      this.refs.password.refs.input.refs.input.focus()
    }
  }

  @autobind
  handlePasswordKey(event) {
    if (event.charCode === 13 || event.keyCode === 13) {
      this.login()
    }
  }

  canLogin() {
    return this.state.email && this.state.password
  }

  renderButtons() {
    return (
      <div className={styles.buttonsContainer}>
        <Button
          disabled={!this.canLogin()}
          primary
          onClick={this.login}
          fullWidth
          loading={this.props.isLoading}
        >
          <Translate tr="auth.pages.login" />
        </Button>
      </div>
    )
  }
  

  renderLoginInfo(){
    let context = contextUrl;
    if(context === 'pi.tufirma.digital' || context === 'test.tufirma.digital' || context === 'yapo.tufirma.digital' ){
      return ( 
        <div>
          <p className={styles.titleText}><b>Bienvenido a la plataforma de firma digital de Yapo</b></p>
          <p className={styles.detailTextMini}>Dado que este servicio es prestado por tuFirma.Digital, no utiliza los datos
           de tu cuenta en Yapo. Es necesario crear una cuenta de tuFirma.digital..</p>
        </div>  )
    } else {
      return ( 
        <div>
          <p className={styles.titleText}><b>Bienvenido a tu plataforma de firma digital</b></p>
        </div>  )
    } 
  }

  render() {
    if(this.props.me){
      console.log("Hay me", this.props.usersData);
      this.props.router.push('/')
    } else {
      console.log("NO Hay me", this.props.me);
    }
    return (
      <div>
        { this.renderLoginInfo() }
        {/* <Social {...this.props} /> */}
        <Form state={this.state} onChange={changes => this.setState(changes)}>
          <Field
            fieldName="email"
            type={Text}
            autoFocus
            fieldType="email"
            placeholder={translate('auth.pages.email')}
            onKeyPress={this.handleEmailKey}
          />
          <br />
          <Field
            fieldName="password"
            type={Text}
            ref="password"
            fieldType="password"
            placeholder={translate('auth.pages.password')}
            onKeyPress={this.handlePasswordKey}
          />
        </Form>
        {this.renderButtons()}
        <br />
        <Translate tr="auth.pages.otherLinksInLogin" />
        <br/>
            <Translate tr="auth.pages.otherLinkForgetPassword" />
        <br/>
            <Translate tr="auth.logintoken.LoginToken" />
        {/* <ul>
          <li>
            </li>
          <li>
            </li>
        </ul> */}
        <br />
          <div>
            Para buscar información de un documento debes
            {' '}
            <Link to='/docVerify'>Validar Documento</Link>
          </div>
        <br />
        <TOS />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/App/Pages/Auth/Login.js